if (!customElements.get('anchor-links')) {
  customElements.define(
    'anchor-links',
    class AnchorLinks extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        document.addEventListener('DOMContentLoaded', () => {
          this.init();
        });
      }

      init() {
        this.addDelegatedClickListeners();
        this.scrollToActiveAnchor();
      }

      addDelegatedClickListeners() {
        this.addEventListener('click', (e) => {
          const clickedAnchorLink = e.target.closest('[data-target-id]');
          if (!clickedAnchorLink) return;

          const targetSectionID = clickedAnchorLink.dataset.targetId;
          const targetSection = document.getElementById(targetSectionID);
          if (!targetSection) return;

          const url = new URL(window.location);
          if (url.searchParams.get('anchor')) {
            url.searchParams.delete('anchor');
          }
          url.searchParams.append("anchor", targetSectionID);
          window.history.pushState({}, ``, url);
          targetSection.style.scrollMarginTop = `${document.querySelector('[data-top-menu]')?.offsetHeight + 16}px`;
          setTimeout(() => {
            targetSection.scrollIntoView();
          }, 10);
        });
      }

      scrollToActiveAnchor() {
        const url = new URL(window.location);
        if (!url.searchParams.get(`anchor`)) return
        const anchorID = url.searchParams.get(`anchor`);
        const headerHeight = document.querySelector('[data-top-menu]').offsetHeight;
        const windowFactor = window.innerWidth > 768 ? 450 : 500;
        const anchorTargetElOffsetTop = document.getElementById(anchorID) ? (document.getElementById(anchorID).offsetTop - headerHeight + windowFactor) : false;
        if (!anchorTargetElOffsetTop) return
        
        window.scrollTo({ top: anchorTargetElOffsetTop, left: 0, behavior: 'smooth' });
      }
    }
  );
}